import React from "react";
import "./Table.scss";

function Table({ children, className }) {
  return <table className={className ? className : "Table"}>{children}</table>;
}

export default Table;
